export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Номер"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ім'я"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Дії"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Редагувати інформацію про інкасатора"])}
}